import ua from 'universal-analytics'
import getUserKey from './userContext'
import _ from 'lodash'

export const gerarTokenLoginIntegradoUrl = '/bff/auth/login-integrado'

export const loginPorTokenLoginIntegradoUrl = '/bff/auth/login-por-login-integrado'

const ambienteKey = 'ambienteKey'
const unidadesKey = 'unidadesKey'
const responsabilidadeKey = 'responsabilidadeKey'
const pecasAbertasKey = 'pecasAbertasKey'
const processosAbertosKey = 'processosAbertosKey'
const visaoKey = 'visaoKey'

export const salvarAmbiente = (ambiente) => {
  localStorage.setItem(ambienteKey, ambiente)
}

export const removerAmbiente = () => {
  localStorage.removeItem(ambienteKey)
}

export const getAmbiente = () => {
  return localStorage.getItem(ambienteKey)
}

export const salvarPecasAbertas = (pecas) => {
  localStorage.setItem(getUserKey(pecasAbertasKey), JSON.stringify(pecas))
}

export const getPecasAbertas = () => {
  const pecas = localStorage.getItem(getUserKey(pecasAbertasKey))
  return pecas ? JSON.parse(pecas) : pecas
}

export const salvarProcessosAbertos = (processos) => {
  localStorage.setItem(getUserKey(processosAbertosKey), JSON.stringify(processos))
}

export const getProcessosAbertos = () => {
  const processos = localStorage.getItem(getUserKey(processosAbertosKey))
  return processos ? JSON.parse(processos) : processos
}

export const salvarUnidades = (unidades) => {
  localStorage.setItem(getUserKey(unidadesKey), JSON.stringify(unidades))
}

export const salvarResponsabilidade = (responsabilidade) => {
  localStorage.setItem(getUserKey(responsabilidadeKey), responsabilidade)
}

export const getResponsabilidade = () => {
  return localStorage.getItem(getUserKey(responsabilidadeKey))
}

export const getUnidades = () => {
  const unidades = localStorage.getItem(getUserKey(unidadesKey))
  return unidades ? JSON.parse(unidades) : unidades
}

export const salvarVisao = (visao) => {
  localStorage.setItem(getUserKey(visaoKey), visao)
}

export const getVisao = (codigoUsuario) => {
  return localStorage.getItem(`${visaoKey}_${codigoUsuario}`)
}

export const isAmbienteProd = () => getAmbiente() === 'producao'

export const isAmbienteDev = () => getAmbiente() === 'desenvol' || getAmbiente() === 'e2e'

export const isAmbienteLocal = () => getAmbiente() === 'local'

export const isAmbienteLocalOuDev = () => isAmbienteLocal() || isAmbienteDev()

export const isAmbienteE2e = () => getAmbiente() === 'e2e'

let browserHistory

export const setBrowserHistory = (history) => {
  browserHistory = history
}

export const getBrowserHistory = () => browserHistory

let visitor = null

export const initGoogleAnalytics = (usuario) => {
  if (isAmbienteProd()) {
    if (_.isNil(usuario)) return

    visitor = ua('UA-134392003-1', usuario, { strictCidFormat: false })
  }
}

export const notifyGoogleAnalyticsTracking = (pathname) => {
  if (isAmbienteProd()) {
    if (_.isNil(visitor)) return

    visitor.pageview(pathname, (err) => {
      if (err) console.log(JSON.stringify(err))
    })
    visitor.screenview(`(${pathname}) screenview`, 'e-TCU Gerencial', (err) => {
      if (err) console.log(JSON.stringify(err))
    })
  } else {
    console.log(`notifyGoogleAnalyticsTracking simulated: pathname "${pathname}"`)
  }
}

export const notifyGoogleAnalyticsEventTracking = (category, action) => {
  if (isAmbienteProd()) {
    if (_.isNil(visitor)) return

    visitor.event(category, action, (err) => {
      if (err) console.log(JSON.stringify(err))
    })
  } else {
    console.log(
      `notifyGoogleAnalyticsEventTracking simulated: category "${category}" - action "${action}"`
    )
  }
}
